export const enumTiposUsuario = [
	{ id: 'ADMINISTRADOR', descricao: 'Administrador' },
	{ id: 'MOTORISTA', descricao: 'Motorista' },
	{ id: 'RESPONSAVEL', descricao: 'Responsável' }
];

export const enumTiposUsuarioComum = [
	{ id: 'MOTORISTA', descricao: 'Motorista' },
	{ id: 'RESPONSAVEL', descricao: 'Responsável' }
];

export const enumTipoHorario = [
    { id: 'JORNADA', descricao: 'Jornada' },
    { id: 'REFEICAO', descricao: 'Refeição' }
];

export const enumTipoTitulos = [
    { id: 'ABERTOS', descricao: 'Abertos' },
    { id: 'QUITADOS', descricao: 'Quitados' }
];

export const enumTipoRelatorioHodometro = [
    { id: 'VEICULO', descricao: 'Por Veículo' },
    { id: 'MOTORISTA', descricao: 'Por Motorista' }
];

export const enumTipoRelatorioTempoCliente = [
    { id: 'CLIENTE', descricao: 'Por Cliente' },
    { id: 'MOTORISTA', descricao: 'Por Motorista' }
];

export const enumTempoEspera = [
    { id: 'TE24', descricao: 'Mais de 24 Horas' },
    { id: 'TE48', descricao: 'Mais de 48 Horas' },
    { id: 'TE72', descricao: 'Mais de 72 Horas' },
    { id: 'TE96', descricao: 'Mais de 96 Horas' },
    { id: 'TE120', descricao: 'Mais de 120 Horas' },
];

export enum TipoSituacaoEntrega {
    CHECKIN = 'CHECKIN',
    DEVOLUCAO_PARCIAL = 'DEVOLUCAO_PARCIAL',
    DEVOLUCAO_TOTAL = 'DEVOLUCAO_TOTAL',
    ENTREGUE = 'ENTREGUE',
    FINALIZADA = 'FINALIZADA',
    PENDENTE = 'PENDENTE',
    ESPERA = 'ESPERA',
    RECEBIMENTO_PENDENTE = 'RECEBIMENTO_PENDENTE',
    REENTREGA = 'REENTREGA',
    SOLICITADA_DEVOLUCAO = 'SOLICITADA_DEVOLUCAO'
}

export const enumSituacoesEntrega = [
    { id: TipoSituacaoEntrega.CHECKIN, descricao: 'CHECKIN' },
    { id: TipoSituacaoEntrega.DEVOLUCAO_PARCIAL, descricao: 'DEVOLUÇÃO PARCIAL' },
    { id: TipoSituacaoEntrega.DEVOLUCAO_TOTAL, descricao: 'DEVOLUÇÃO TOTAL' },
    { id: TipoSituacaoEntrega.ENTREGUE, descricao: 'ENTREGUE' },
    { id: TipoSituacaoEntrega.FINALIZADA, descricao: 'FINALIZADA' },
    { id: TipoSituacaoEntrega.PENDENTE, descricao: 'PENDENTE' },
    { id: TipoSituacaoEntrega.ESPERA, descricao: 'ESPERA' },
    { id: TipoSituacaoEntrega.RECEBIMENTO_PENDENTE, descricao: 'RECEBIMENTO PENDENTE' },
    { id: TipoSituacaoEntrega.REENTREGA, descricao: 'REENTREGA' }
];

export enum TipoSituacaoRomaneio {
    ABERTO = 'ABERTO',
    INICIADO = 'INICIADO',
    CANCELADO = 'CANCELADO',
    FINALIZADO = 'FINALIZADO',
    FECHADO = 'FECHADO',
    REJEITADO = 'REJEITADO',
    BLOQUEADO = 'BLOQUEADO',
}

export const enumSituacoesRomaneio = [
    { id: TipoSituacaoRomaneio.ABERTO, descricao: 'Aberto' },
    { id: TipoSituacaoRomaneio.INICIADO, descricao: 'Iniciado' },
    { id: TipoSituacaoRomaneio.CANCELADO, descricao: 'Cancelado' },
    { id: TipoSituacaoRomaneio.FINALIZADO, descricao: 'Finalizado' },
    { id: TipoSituacaoRomaneio.FECHADO, descricao: 'Fechado' },
    { id: TipoSituacaoRomaneio.REJEITADO, descricao: 'Rejeitado' },
    { id: TipoSituacaoRomaneio.BLOQUEADO, descricao: 'Bloqueado' },
]

export const enumEventosMotorista = [
    { id: 'RETORNO_VIAGEM', descricao: 'Retorno Viagem' },
    { id: 'ROMANEIO_INICIADO_SEM_ENTREGA_HOJE', descricao: 'Romaneios iniciados sem entregas registradas hoje' },
	{ id: 'ROMANEIO_INICIADO', descricao: 'Veículos em viagem' }
]

export const enumTipoEmail = [
    { id: 'EMAIL', descricao: 'EMAIL' },
    { id: 'EMAILNFE', descricao: 'EMAILNFE' }
];

export const enum enumTipoRelatorio {
	PDF = '.pdf',
	EXCEL = '.xlsx'
}

export const enum enumTipoAlertaParametro {
	ALERTA_SONORO_NOTIFICACOES = 'ALERTA_SONORO_NOTIFICACOES',
	ALERTA_SONORO_NOTIFICACOES_TEMPO = 'ALERTA_SONORO_NOTIFICACOES_TEMPO',
	OUTRO_ERP = 'OUTRO_ERP'
}

export enum enumTipoParametro {
	GERAL = 'GERAL',
	FILIAL = 'FILIAL',
	USUARIO = 'USUARIO'
}


export const  tipoParametroDispositivoApenasFiliais: string[] = [
	'ALERTA_TEMPO_MAXIMO_ENTREGA', 'ALERTA_TEMPO_MAXIMO_ESPERA', 'ALERTA_TEMPO_MAXIMO_LOCOMOCAO_ENTRE_CLIENTES',
	'ALERTA_FURO_SEQUENCIA_ENTREGA', 'ALERTA_EM_CASO_DE_DEVOLUCAO', 'ALERTA_EM_CASO_DE_FILA_ESPERA', 'ALERTA_FURO_CERCA',
	'ALERTA_BATERIA_PROX_FIM', 'EXIBIR_NOTIFICACAO_RETORNO_VIAGEM', 'NAO_EXIBIR_NOTIFICACOES_LIDAS', 'OBRIGAR_FIM_ROM_COM_ROM_INICIADO',
    'DIAS_FIM_ROM_COM_ROM_INICIADO', 'MANTER_ROM_FINALIZADO_PAINEL_MONITORAMENTO', 'OBRIGAR_REGISTRO_FOTO_ENTREGA', 'BAIXAR_TIT_MAXPAG_PIX_WINTHOR_DMS',
	'EXIBIR_NOTIFICACAO_OCORRENCIA', 'CANCELAR_LINK_MAXPAG_APK'
];

export const enumSituacoesRomaneioListagem = [
	{id: 'ABERTO'},
	{id: 'INICIADO'},
	{id: 'CANCELADO'},
	{id: 'FINALIZADO'},
	{id: 'FECHADO'},
	{id: 'REJEITADO'},
	{id: 'BLOQUEADO'},
];


export const enumSituacoesEntregasPainel = [
	{id: 'EN', descricao: 'Entregue'},
	{id: 'Será entregue hoje', descricao: 'Será entregue hoje'},
	{id: 'Entregue (Hoje)', descricao: 'Entregue (Hoje)'},
	{id: 'PD',  descricao: 'Pendente'},
	{id: 'SD', descricao: 'Solicitação Devolução'},
	{id: 'EP', descricao:  'Espera'},
	{id: 'CK', descricao: 'Check-in'},
	{id: 'DT', descricao: 'Devoluções Totais'},
	{id: 'DP', descricao: 'Devoluções Parciais'},
	{id: 'RE', descricao: 'Reentregas'},
	{id: 'FN', descricao: 'Finalizadas'},
	{id: 'Reagendada',  descricao: 'Reagendada'}
];


export enum NotasFiscalGridColunasEnum {
    ENTREGA = 'idEntrega',
    NOTA = 'numNota',
    CLIENTE = 'clienteIdNome',
    SITUACAO_ENTREGA = 'situacaoEntrega',
    CANHOTO = 'canhoto',
    CHECKIN = 'dataCheckin',
    INICIO_DESCARGA = 'dataInicioDescarga',
    TERMINO_DESCARGA = 'dataTerminoDescargaFilter',
    ACOES = 'ACOES'
}

export enum TipoStatusCanhoto {
	NAO_VALIDO = 'NAO_VALIDO',
	VALIDO = 'VALIDO',
}

export const enumCanhotoStatus = [
	{ codigo: TipoStatusCanhoto.NAO_VALIDO, descricao: 'NÃO VÁLIDO' },
	{ codigo: TipoStatusCanhoto.VALIDO, descricao: 'VÁLIDO' },
];
